import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

export const userIdentityStatusSchema = z.enum(['active', 'inactive', 'registrable']);
export type UserIdentityStatus = z.infer<typeof userIdentityStatusSchema>;
export const UserIdentityStatus = userIdentityStatusSchema.enum;
export const allUserIdentityStatuses = userIdentityStatusSchema.options;

export const plainUserIdentitySchema = z.object({
  id: z.string(),
  iss: z.string(),
  sub: z.string().nullable(),
  status: userIdentityStatusSchema,
});
export type PlainUserIdentity = z.infer<typeof plainUserIdentitySchema>;

export const userIdentitySchema = plainUserIdentitySchema.extend({
  userId: z.string(),
  createdAtInstant: z.instanceof(Temporal.Instant),
  updatedAtInstant: z.instanceof(Temporal.Instant),
});
export type UserIdentity = z.infer<typeof userIdentitySchema>;

export function userIdentityStatusLabel(status: UserIdentityStatus): string {
  switch (status) {
    case UserIdentityStatus.active:
      return 'Active';
    case UserIdentityStatus.inactive:
      return 'Inactive';
    case UserIdentityStatus.registrable:
      return 'Registrable';
  }
}

const nullableTrimmedOptionalString = z
  .string()
  .nullable()
  .optional()
  .transform((val) => val?.trim() || null);

export const userIdentityProviderUpdateSchema = z.object({
  status: userIdentityStatusSchema,
  iss: nullableTrimmedOptionalString,
  sub: nullableTrimmedOptionalString,
});
export type UserIdentityProviderUpdate = z.infer<typeof userIdentityProviderUpdateSchema>;

export const userIdentityProviderKeySchema = z.enum(['google', 'edlink']);
export type UserIdentityProviderKey = z.infer<typeof userIdentityProviderKeySchema>;
export const UserIdentityProviderKey = userIdentityProviderKeySchema.enum;

export const updateUserIdentitiesOptionsSchema = z.object({
  google: userIdentityProviderUpdateSchema,
  edlink: userIdentityProviderUpdateSchema,
});
export type UpdateUserIdentitiesOptions = z.infer<typeof updateUserIdentitiesOptionsSchema>;

export function userIdentityProviderKeyLabel(providerKey: UserIdentityProviderKey): string {
  switch (providerKey) {
    case UserIdentityProviderKey.google:
      return 'Google Workspace';
    case UserIdentityProviderKey.edlink:
      return 'Edlink';
  }
}
